import { ArrowUpRight } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { formatCurrency } from "@/lib/utils";

import type { StockTransformationLine } from "@artisancode/api-types";

/** What landed at the bar: the ingredient a package opened into, or the same direct-use item. */
export function RepackingOutputLines({
  line,
}: {
  line: StockTransformationLine;
}) {
  return (
    <div className="rounded-lg border p-3">
      <div className="flex items-center justify-between border-b pb-2">
        <span className="flex items-center gap-1.5 font-semibold text-foreground">
          <ArrowUpRight className="h-4 w-4 text-emerald-500" />
          Masuk ke Stok Bar
        </span>
        <Badge variant="outline" className="text-[10px]">
          Wadah: Repacking
        </Badge>
      </div>
      <div className="mt-2.5 flex items-center justify-between">
        <div>
          <p className="font-medium text-foreground">{line.itemName}</p>
          {line.itemSku && (
            <p className="font-mono text-[11px] text-muted-foreground">
              SKU: {line.itemSku}
            </p>
          )}
        </div>
        <div className="text-right">
          <p className="text-sm font-semibold text-foreground">
            {line.qty.toLocaleString("id-ID")} {line.uomName}
          </p>
          <p className="text-[11px] text-muted-foreground">
            @ {formatCurrency(line.unitCost)} / {line.uomName}
          </p>
        </div>
      </div>
    </div>
  );
}
